import { Box, Grid } from "@mui/material";
import React, { useEffect } from "react";
import OrderCard from "./OrderCard";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useDispatch, useSelector } from "react-redux";
import { getOrderHistory } from "../../../Redux/Customers/Order/Action";
import BackdropComponent from "../BackDrop/Backdrop";
import Navbar from "../../../components/Navbar";
import Footer from "../../../components/Footer";

const orderStatus = [
  { label: "On The Way", value: "onTheWay" },
  { label: "Delivered", value: "delivered" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Returned", value: "returned" },
];

const Order = () => {
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");
  const { order } = useSelector((store) => store);

  useEffect(() => {
    dispatch(getOrderHistory({ jwt }));
  }, [jwt]);

  console.log("users orders ", order.orders);

  return (
    <div className="bg-black text-white min-h-screen pt-40 h-fit">
      <Navbar />
      <Box className="">
        <Grid container spacing={0} sx={{ justifyContent: "space-between" }}>

          <div className="w-full">
            <Box className="space-y-5">
              {order.orders?.length > 0 && order.orders?.map((order) =>
                order?.orderItems?.map((item, index) => (
                  <OrderCard key={index} item={item} order={order} />
                ))
              )}
            </Box>
          </div>
        </Grid>

        <BackdropComponent open={order.loading} />
      </Box>
      <Footer />
    </div>
  );
};

export default Order;
